import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const ProductAssignmentPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Asignación de Productos</h2>
          <p>Selecciona qué productos participan en qué campañas.</p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default ProductAssignmentPage;
